import script from "./Coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./Coupon.vue?vue&type=script&setup=true&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=d3c9b464&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3c9b464"]])

export default __exports__